import { render, staticRenderFns } from "./MonthBillDetail.vue?vue&type=template&id=66774c32&scoped=true&"
import script from "./MonthBillDetail.vue?vue&type=script&lang=js&"
export * from "./MonthBillDetail.vue?vue&type=script&lang=js&"
import style0 from "./MonthBillDetail.vue?vue&type=style&index=0&id=66774c32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66774c32",
  null
  
)

export default component.exports